import App from 'App';
import 'assets/css/main.css';
import 'assets/css/responsive.css';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'reducer';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

reportWebVitals();
